<template>
  <div class="comm_area">
    <ul class="comm_box">
      <li v-for="item in list" :key="item.id">
        <div
          class="user_info"
          v-if="item.isDel === 'N' && item.isReport === 'N'"
        >
          <p>{{ item.writer }}</p>
          <p class="writer" v-if="item.userId == userId">
            <i class="dot"></i>
            <span>글쓴이</span>
          </p>
          <p class="writer red" v-if="item.storeId == storeId">
            <i class="dot red"></i>
            <span>답변자</span>
          </p>
          <i class="i_reply_more" @click="fnMore(item)"></i>
        </div>
        <!-- 패딩값 때문에 넣어둠 -->
        <div v-else class="user_info"></div>
        <p class="txt" v-if="item.isDel === 'N' && item.isReport === 'N'">
          {{ item.contents }}
        </p>
        <p class="txt disable" v-else-if="item.isDel === 'Y'">
          해당 답글은 작성자에 의해 삭제되었습니다.
        </p>
        <p class="txt disable" v-else-if="item.isReport === 'Y'">
          해당 답글은 신고에 의해 숨김 처리되었습니다.
        </p>
        <div
          class="info_zone"
          v-if="item.isDel === 'N' && item.isReport === 'N'"
        >
          <div class="sec_2">
            <div class="left">
              <span class="light">{{ item.createdAt | moment('from') }}</span>
              <span
                ><i
                  :class="`i_reply_like_${item.isLike === 'Y' ? 'on' : 'off'}`"
                  @click="fnLike(item.id)"
                ></i
                >{{ item.likeCnt }}</span
              >
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'component-community-detail-section-comment',
  description: '커뮤니티 > 댓글 영역',
  props: {
    boardType: {
      type: String,
      default: 'KNOWHOW',
      description: 'KNOWHOW: 지식인, BOARD: 자유게시판',
    },
    list: Array,
    userId: Number,
    storeId: Number,
  },
  methods: {
    fnMore(item) {
      this.$emit('more', item);
    },
    fnLike(id) {
      const found = this.list.filter(item => item.id === id);
      this.$emit('like', found[0]);
    },
  },
};
</script>

<style></style>
